export const imagesAvaiableTypesList = new Set(['webp']);

export const isSupportedImageType = type => imagesAvaiableTypesList.has(type);
